import { useCallback, useEffect, useState } from 'react';
import { getApiUrl } from '../config/api';
import { getAuthToken } from '../utils/authUtils';
import type { ScannerData } from '../types/ScannerData';

const DEFAULT_POLL_MS = 30_000;

export function useRtlLegacyScannerData(pollMs = DEFAULT_POLL_MS) {
  const [rows, setRows] = useState<ScannerData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [updatedAt, setUpdatedAt] = useState('');

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(getApiUrl('/api/legacy-rtl/data'), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          ...(getAuthToken() ? { Authorization: `Bearer ${getAuthToken()}` } : {}),
        },
        cache: 'no-store',
      });
      if (!res.ok) {
        setError(`RTL ${res.status}`);
        return;
      }
      const json = await res.json();
      const data = Array.isArray(json?.data) ? (json.data as ScannerData[]) : [];
      setRows(data);
      setUpdatedAt(new Date().toISOString());
      setError('');
    } catch (e) {
      setError((e as Error)?.message || 'RTL fetch failed');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
    const id = window.setInterval(() => void reload(), pollMs);
    return () => window.clearInterval(id);
  }, [reload, pollMs]);

  return { rows, loading, error, updatedAt, reload };
}
